<template>
  <div
    class="or_line_con"
    v-if="currentCruiseList && currentCruiseList.length > 0"
  >
    <div class="rec_head_con">
      <div class="line"></div>
      <div class="rec_title">航线推荐</div>
      <div
        class="rec_rel_con changeCruise"
        @click="switchRec(nation)"
        v-show="abroadCruiseList.length > 0"
      >
        <img class="rel_icon" src="../../assets/reload.png" />
        <span class="rel_text">换一批</span>
      </div>
    </div>
    <div class="rec_con">
      <div
        class="rec_item"
        v-for="(item, index) in currentCruiseList"
        :key="item.cruiseId"
      >
        <div class="rec_img">
          <img :src="item.cruiseImg" :alt="item.cruiseName" />
        </div>
        <div class="rec_info_con">
          <div class="rec_title">
            <a href="javascript: void(0)" @click="goto(item, index)">{{
              interceptChar(item.cruiseName, 20)
            }}</a>
          </div>
          <div class="ship_time">
            <span class="line_label">{{ item.cruiseDateNight }}</span>
            <span>{{ item.shipCNName }}</span>
          </div>
          <div class="rec_saildate">
            {{ getSailDateText(item.cruiseSailDate) }} -
            {{ getSailDateText(item.cruiseEndDate) }}
          </div>
          <div class="rec_pic">
            <span style="font-size: 14px; font-weight: 600">￥</span>
            <span style="font-size: 24px; font-weight: 600">{{
              item.cruiseBestPrice
            }}</span>
            <span style="font-size: 14px; font-weight: 400">/人起 (含税)</span>
          </div>
          <div>
            <span
              style="font-size: 14px; font-weight: 400"
              v-show="item.amountPerNight > 0"
              >平均每晚￥{{ item.amountPerNight }}/人起</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { interceptChar, gioAdsTracking } from "@/utilities/tools";
export default {
  name: "PromoCruise",
  props: {
    cruiseType: {
      type: Number,
      default: 0,
    },
    shipCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userToken: "",
      domesticCruiseList: [],
      abroadCruiseList: [],
      currentCruiseList: [],
      nation: 0, // 0 代表国内  1代表国外
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    interceptChar(str, num) {
      return interceptChar(str, num);
    },
    async init() {
      this.initPage();
    },
    async initPage() {
      this.userToken = this.$store.state.user.userToken;
      const data = await this.getPromoCruise(2);

      this.domesticCruiseList = data.filter((item) => item.isRow === false);
      this.abroadCruiseList = data.filter((item) => item.isRow === true);
      this.currentCruiseList =
        this.nation === 0 ? this.domesticCruiseList : this.abroadCruiseList;
    },
    goto(item, index) {
			const url = item.isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}&cruiseId=${item.cruiseId}`
			: `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}`;
			gioAdsTracking({
				"adsType": "rcm",
				"rcmOrder": (index+1),
				"desUrl": url
			});
      if (item.isRow) {
        window.location.href = `${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}&cruiseId=${item.cruiseId}`;
      } else {
        this.$router.push(
          `/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}`
        );
      }
    },
    switchRec(nation) {
      this.nation = nation ? 0 : 1;
      this.currentCruiseList =
        this.nation === 0 ? this.domesticCruiseList : this.abroadCruiseList;
    },
    async getPromoCruise(isRow) {
      const { errMsg, data, success } = await api.cruise.getPromoCruiseHP({
        userName: this.userToken,
        isRow,
        type: this.cruiseType,
        shipCode: this.shipCode,
      });
      if (success) {
        return data;
      } else {
        window.console.log(errMsg);
      }
    },
    getSailDateText(sailDate) {
      return sailDate.split("-").join("/");
    },
  },
};
</script>

<style scoped>
.or_line_con {
  min-width: 953px;
  overflow: hidden;
  margin: 20px auto 18px auto;
}

.or_line_con .rec_head_con {
  position: relative;
  padding: 11px 0;
}

.or_line_con .rec_head_con .line {
  width: 100%;
  height: 1px;
  background-color: #d3dadd;
}

.or_line_con .rec_head_con .rec_title {
  width: 110px;
  position: absolute;
  top: 0;
  left: calc(50% - 60px);
  font-size: 22px;
  line-height: 22px;
  color: #000000;
  background-color: #f5f5f5;
  text-align: center;
}

.or_line_con .rec_head_con .rec_rel_con {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f5f5f5;
  padding-left: 6px;
}
.changeCruise {
  cursor: pointer;
}
.or_line_con .rec_head_con .rec_rel_con .rel_icon {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  margin-right: 4px;
  margin-top: -2px;
}

.or_line_con .rec_head_con .rec_rel_con .rel_text {
  font-size: 14px;
  color: #747d80;
}

.or_line_con .rec_con {
  overflow: hidden;
}

.or_line_con .rec_con .rec_item {
  float: left;
  margin-top: 20px;
  margin-right: 18px;
  overflow: hidden;
  width: 48%;
  background-color: #fff;
  padding: 10px;
}

.or_line_con .rec_con .rec_item .rec_img {
  float: left;
  width: 155px;
  height: 155px;
  overflow: hidden;
  background-size: cover;
}
.rec_img img {
  width: 100%;
}

.or_line_con .rec_con .rec_item .rec_info_con {
  float: left;
  margin-left: 17px;
  color: #282b2c;
}

.or_line_con .rec_con .rec_item .rec_info_con .rec_title {
  width: 265px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #006ab9;
  margin-top: 3px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.or_line_con .rec_con .rec_item .rec_info_con .ship_time {
  font-size: 14px;
  padding: 5px 0px;
  line-height: 16px;
  margin: 2px 0;
  font-weight: 400;
}

.or_line_con .rec_con .rec_item .rec_info_con .rec_saildate {
  font-weight: 400;
}

.or_line_con .rec_con .rec_item .rec_info_con .ship_time .line_label {
  display: inline-block;
  margin-right: 14px;
  font-weight: 400;
}

.or_line_con .rec_con .rec_item .rec_info_con .rec_pic {
  color: #ffa70d;
  font-size: 14px;
  font-weight: 400;
}
</style>
